import {
  GET_ADMIN_ROLES_BY_ORGANIZATION_ID,
  useLazyGetAdminRolesByOrganizationId,
} from "../operations/queries/getAdminRolesByOrganizationId";
import { useLazyGetAdminPermissions } from "../operations/queries/getAdminPermissions";
import AdminRolesList from "../components/AdminRolesList";
import { useAddAdminRole } from "../operations/mutations/addAdminRole";
import { useUpdateAdminRole } from "../operations/mutations/updateAdminRole";
import { useEffect } from "react";
import { useAppContext } from "../hooks/useAppContext";

const AdminRolesListContainer = () => {
  const { currentOrganization } = useAppContext();

  const {
    getAdminRolesByOrganizationId: getAdminRoles,
    data: adminRoles,
    status: getAdminRolesStatus,
  } = useLazyGetAdminRolesByOrganizationId();
  const { getAdminPermissions, data: adminPermissions } = useLazyGetAdminPermissions();
  const { mutate: addAdminRoleMutate, status: addAdminRoleStatus } = useAddAdminRole();
  const { mutate: updateAdminRoleMutate, status: updateAdminRoleStatus } = useUpdateAdminRole();

  useEffect(() => {
    if (currentOrganization) {
      getAdminRoles({ variables: { organizationId: currentOrganization.id } });
    }
  }, [currentOrganization, getAdminRoles]);

  useEffect(() => {
    getAdminPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddAdminRole = (displayName: string, permissionNames: string[]) => {
    if (currentOrganization) {
      addAdminRoleMutate({
        refetchQueries: [
          { query: GET_ADMIN_ROLES_BY_ORGANIZATION_ID, variables: { organizationId: currentOrganization.id } },
        ],
        variables: {
          displayName,
          organizationId: currentOrganization.id,
          permissionNames,
        },
      });
    }
  };

  const handleEditAdminRole = (roleId: string, displayName: string, permissionNames: string[]) => {
    if (currentOrganization) {
      updateAdminRoleMutate({
        refetchQueries: [
          { query: GET_ADMIN_ROLES_BY_ORGANIZATION_ID, variables: { organizationId: currentOrganization.id } },
        ],
        variables: {
          organizationId: currentOrganization.id,
          roleId,
          displayName,
          permissionNames,
        },
      });
    }
  };

  return (
    <AdminRolesList
      isAdminRolesLoading={getAdminRolesStatus.loading}
      adminRoles={adminRoles && adminRoles.adminRolesByOrganizationId}
      adminPermissions={adminPermissions && adminPermissions.adminPermissions}
      onAddAdminRole={handleAddAdminRole}
      addAdminRoleStatus={addAdminRoleStatus}
      onEditAdminRole={handleEditAdminRole}
      editAdminRoleStatus={updateAdminRoleStatus}
    ></AdminRolesList>
  );
};

export default AdminRolesListContainer;
